import { render, staticRenderFns } from "./zhuanlanComponent.vue?vue&type=template&id=47879a86&scoped=true"
import script from "./zhuanlanComponent.vue?vue&type=script&lang=js"
export * from "./zhuanlanComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47879a86",
  null
  
)

export default component.exports